import React from 'react';
import { uid } from 'react-uid';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import CONTENT from 'pods/forms/_formBuilder.content';
import Collapse from 'core/components/Collapse';

import * as S from './ErrorSummary.style';

interface IProps {
	summaryData: {
		fieldId: string;
		label: string;
		errors: string[];
	}[];
}

const ErrorSummary = ({ summaryData }: IProps) => (
	<Collapse isOpen={false}>
		<S.ErrorSummaryContainer>
			<h3>{CONTENT.SUMMARY.TITLE}</h3>
			<S.ErrorSummaryList>
				<TransitionGroup role="alert" aria-live="assertive">
					{summaryData.map(item => (
						<CSSTransition
							key={item.fieldId}
							timeout={300}
							classNames="collapse"
						>
							<li>
								<S.ErrorSummaryLink
									href={`#${item.fieldId}`}
									onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
										e.preventDefault();
										const errorField = document.getElementById(item.fieldId);

										if (errorField) {
											errorField.focus();
										}
									}}
								>
									<strong>{`${item.label}: `}</strong>

									{item.errors.length > 1 ? (
										<ul>
											{item.errors.map(err => (
												<li key={uid(err)}>{err}</li>
											))}
										</ul>
									) : (
										<>{item.errors[0]}</>
									)}
								</S.ErrorSummaryLink>
							</li>
						</CSSTransition>
					))}
				</TransitionGroup>
			</S.ErrorSummaryList>
		</S.ErrorSummaryContainer>
	</Collapse>
);

export default ErrorSummary;
